{
  "dismiss": "Lukk"
}
